import React from "react";
import { DashboardJds } from "./Dashboard/Dashboard";

export function DashboardPage() {
  return <DashboardJds />;
}
